import { AnimatePresence, motion } from "motion/react";

interface Props {
  currentKey: string;
  level: number;
  children: React.ReactNode;
  durationSeconds: number;
}

const LevelChangeAnimation: React.FC<Props> = ({ durationSeconds, children, currentKey }) => {
  const buttonVariants = {
    initial: {
      opacity: 0,
    },
    enter: { x: 0, opacity: 1 },
    exit: {
      opacity: 0,
    },
  };

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        width: "100%",
        height: "4rem",
      }}
    >
      <AnimatePresence>
        <motion.div
          key={currentKey}
          initial="initial"
          animate="enter"
          exit="exit"
          variants={buttonVariants}
          transition={{
            duration: durationSeconds,
          }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
          }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default LevelChangeAnimation;
